import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons'
import { ReactNode, SyntheticEvent } from 'react'
import IWButton from 'shared/components/thunderbolt/IWButton'
import IWTypography from 'shared/components/thunderbolt/IWTypography'
import styled from 'styled-components'

const Section = styled.div`
  display: flex;
  flex-direction: column;
`

const SectionHeader = styled(IWTypography)`
  display: inline-block;
`

const SectionDesc = styled(IWTypography)`
  text-align: left;
  color: ${(props) => props.theme.palette.grey[400]};
  margin-top: 0.25rem;
  margin-bottom: 1rem;
`
const HeaderWithButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

type Props = {
  header: string
  desc?: string
  buttonLabel?: string
  onButtonClick?: (e: SyntheticEvent) => void
  children: ReactNode
}

export default function ({
  header,
  desc,
  buttonLabel,
  onButtonClick,
  children,
}: Props) {
  return (
    <Section>
      <HeaderWithButton>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <SectionHeader
            as="h1"
            size="lg"
            weight="medium"
            fontHue={{ color: 'grey', value: 900 }}
          >
            {header}
          </SectionHeader>

          {desc && <SectionDesc size="sm">{desc}</SectionDesc>}
        </div>

        {onButtonClick && buttonLabel && (
          <IWButton
            icon={faCirclePlus}
            iconPosition="leading"
            onClick={onButtonClick}
          >
            {buttonLabel}
          </IWButton>
        )}
      </HeaderWithButton>
      {children}
    </Section>
  )
}
